import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { PER_PAGE } from '@/config.js';

const usePaginationStore = create(
    persist(
        (set, get) => ({
            // State: Object to store per-page values for different tables
            tablePerPage: {},
            
            // Actions
            getPerPage: (tableName) => {
                const state = get();
                // Return stored value for table, or default from config
                return state.tablePerPage[tableName] || PER_PAGE;
            },
            
            setPerPage: (tableName, perPageValue) => {
                set((state) => ({
                    tablePerPage: {
                        ...state.tablePerPage,
                        [tableName]: perPageValue
                    }
                }));
            },
            
            // Reset a specific table to default
            resetTablePerPage: (tableName) => {
                set((state) => {
                    const newTablePerPage = { ...state.tablePerPage };
                    delete newTablePerPage[tableName];
                    return { tablePerPage: newTablePerPage };
                });
            },
            
            // Reset all tables to default
            resetAllTablesPerPage: () => {
                set({ tablePerPage: {} });
            },
            
            // Get all stored table configurations
            getAllTableConfigs: () => {
                return get().tablePerPage;
            }
        }),
        {
            name: 'pagination-storage',
            getStorage: () => localStorage,
        }
    )
);

export default usePaginationStore;
